var map = {
	"./add-tag.svg": "2be5",
	"./add.svg": "6828",
	"./ai-icon.svg": "d44f",
	"./anpassen.svg": "31e7",
	"./arrow-left-small.svg": "f0f4",
	"./arrow-left.svg": "f3a0",
	"./arrow-right-small.svg": "1c7f",
	"./authentication-image.svg": "c0d5",
	"./board-icon.svg": "dec4",
	"./building.svg": "2a26",
	"./chart-to-settings.svg": "f5a8",
	"./chart.svg": "9f3b",
	"./checkbox.svg": "551a",
	"./checkboxcard.svg": "e0f2",
	"./cheveron-down-icon.svg": "aad6",
	"./chevron-down.svg": "7283",
	"./circle-exclamation.svg": "a281",
	"./clear.svg": "3561",
	"./clipboards.svg": "c18a",
	"./clock-icon.svg": "5a8c",
	"./code-tag.svg": "c768",
	"./codelos-icons.svg": "b3e6",
	"./codelos-logo.svg": "7e54",
	"./cog.svg": "d6e4",
	"./condition.svg": "1297",
	"./copy-icon-new.svg": "ad67",
	"./copy_grey.svg": "e94a",
	"./custom-code-tag.svg": "15f0",
	"./custom-delete.svg": "60f2",
	"./custom-download.svg": "8453",
	"./custom-duplicate.svg": "f3ea",
	"./custom-quit.svg": "eba7",
	"./custom-user.svg": "c1f6",
	"./database-link.svg": "0ab9",
	"./database-model.svg": "06c0",
	"./database-schema-copy.svg": "c863",
	"./database.svg": "60d8",
	"./date.svg": "767c",
	"./daten-icon-gray.svg": "ef73",
	"./daten-icon-light.svg": "33aa",
	"./datetime.svg": "5217",
	"./delete-icon-ai-styles.svg": "c88d",
	"./delete-icon-new.svg": "90ba",
	"./delete-icon.svg": "cd73",
	"./delete_grey.svg": "01ce",
	"./description.svg": "77bd",
	"./document.svg": "5fe1",
	"./download-icon-new.svg": "d813",
	"./download.svg": "9f0f",
	"./download_grey.svg": "6e63",
	"./dropdown-icon.svg": "3914",
	"./dummy-load-data.svg": "b09a",
	"./duplicate.svg": "c05b",
	"./expired.svg": "a924",
	"./eye-icon.svg": "0b6f",
	"./file-icon.svg": "868c",
	"./file.svg": "ea02",
	"./filter-icon.svg": "ad40",
	"./filter.svg": "c86e",
	"./full-screen-icon.svg": "213a",
	"./group-toggle-off.svg": "eb56",
	"./group-toggle-on.svg": "ecfb",
	"./hidden.svg": "47c0",
	"./html.svg": "9f43",
	"./icons-clock.svg": "f163",
	"./icons-icon.svg": "a3f1",
	"./image-icon.svg": "6eb4",
	"./inquiry.svg": "daa8",
	"./left-arrow-nav-bar.svg": "77db",
	"./left-arrow.svg": "f330",
	"./line.svg": "4d6d",
	"./link-to-db.svg": "a964",
	"./list icon.svg": "e7a0",
	"./list.svg": "764e",
	"./lock-locked.svg": "aba3",
	"./lock-open.svg": "0608",
	"./logic.svg": "8409",
	"./mail.svg": "37a8",
	"./media.svg": "b374",
	"./more-icon.svg": "25f0",
	"./new-inquiry.svg": "89ea",
	"./nodata.svg": "175b",
	"./number.svg": "eff2",
	"./object-list.svg": "d0b5",
	"./options.svg": "90bc",
	"./person.svg": "fe85",
	"./plus-icon.svg": "bd72",
	"./quit.svg": "9efc",
	"./radiocard.svg": "4615",
	"./range-icon.svg": "8e95",
	"./refresh.svg": "8d7e",
	"./result-window.svg": "32ba",
	"./right-arrow-nav-bar.svg": "93c3",
	"./search-icon.svg": "3e7d",
	"./series_negative_val.svg": "afab",
	"./setting-icon.svg": "2c13",
	"./setting.svg": "6d1e",
	"./settings-to-chart.svg": "faca",
	"./share-icon-new.svg": "71d7",
	"./share_grey.svg": "491d",
	"./sheet.svg": "894a",
	"./start.svg": "cf11",
	"./status_icon_failed.svg": "f092",
	"./status_icon_success.svg": "6f85",
	"./status_processing_icon.svg": "685f",
	"./text.svg": "4a68",
	"./textarea.svg": "ce9f",
	"./time-trigger.svg": "8707",
	"./title.svg": "ec8d",
	"./todos.svg": "aa59",
	"./toggle.svg": "0b0e",
	"./trash.svg": "5665",
	"./url-link-icon.svg": "80f1",
	"./user.svg": "f41a",
	"./video-icon.svg": "ae45",
	"./wizard.svg": "6052",
	"./workflow-icon-new-gray.svg": "9a3d",
	"./workflow-icon-new-light.svg": "1494",
	"./workflow.svg": "4e9c",
	"./x.svg": "8540"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f1df";